<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props', 'reset-select-product')">
                        </b-tab>
                        <b-tab title="Insurance" :active="showInsuranceSelection" @click="emitEvent('show-insurance-selection')">
                            <InsuranceSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showInsuranceSummary" @click="emitEvent('show-insurance-summary')">
                            <InsuranceSummary />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import InsuranceSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/InsuranceSolution/InsuranceSelection'
import InsuranceSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/InsuranceSolution/InsuranceSummary'

export default {
    props: {
        showInsuranceCompanies: Boolean,
        showInsuranceSelection: Boolean,
        showInsuranceSummary: Boolean,
    },
    components: {
        InsuranceSelection,
        InsuranceSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        }
    },
}
</script>